import { FC } from 'react';
import { Link } from 'react-router-dom';
import { merge } from '../../utils/utility';

interface Props {
  name: string;
  to: string;
  className?: string;
}

export const UserMenuLink: FC<Props> = ({ name, to, className }) => {
  return <Link className={merge("py-2 px-3 text-primary-800 font-semibold bg-primary-std", className)} to={to}>{name}</Link>;
};
